import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-clock-count-down-timer',
  templateUrl: './clock-count-down-timer.component.html',
  styleUrls: ['./clock-count-down-timer.component.scss']
})
export class ClockCountDownTimerComponent implements OnInit {
  @Input() isTimerStarted = false;
  @Input() timerTime;
  public timerString = '30';
  public id = '';
  constructor() { }

  ngOnInit() {
    this.id = this.timerTime === 10 ? 'animation-10-seconds-' : (this.timerTime === 60) ? 'animation-60-seconds-' : '';
    let timer = this.timerTime;
    for (let index = 0; index < timer; index++) {
      setTimeout(() => {
        if (timer >= 0) {
          timer--;
          this.timerString = timer < 10 ? '0' + String(timer) : String(timer);
        }
      }, 1000 * index);
    }
  }

}
